import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface FloatingCTAProps {
  anchorId: string;
}
export function FloatingCTA({
  anchorId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-17" data-mp="38bqr9ps7m56w">
      {visible && <motion.div className="fixed inset-x-3 bottom-3 z-40 md:inset-x-auto md:bottom-6 md:right-6" initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-18" data-mp="33k8rh51xaani">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl border-2 border-white bg-cta px-6 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(16,33,61,0.5)] hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 md:w-auto" data-id="element-19" data-mp="2pce91pma4vm4">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-20" data-mp="26djtwfiwlt5f" />
            Get it now · USD $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}